"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function template(strings) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return (function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        var result = [strings[0]];
        keys.forEach(function (key, i) {
            var value = Number.isInteger(key) ? values[key] : values[keys.indexOf(key)];
            result.push(value, strings[i + 1]);
        });
        return result.join("");
    });
}
exports.template = template;
